import type { ContentfulPageViewModel } from 'autogen/swagger/all';
import { ContentfulLivePreview } from '@contentful/live-preview';
import { ContentfulLivePreviewProvider } from '@contentful/live-preview/react';
import type { ReactNode } from 'react';
import PreviewOverlay from 'components/pages/Contentful/components/PreviewOverlay/PreviewOverlay';

export default function Preview({
    model,
    children
}: { model: ContentfulPageViewModel['useCaseModel']; children: ReactNode }) {
    const { contentfulLocale, previewUserType, contentfulPage } = model;

    if (!ContentfulLivePreview.initialized) {
        ContentfulLivePreview.init({
            locale: contentfulLocale
        });
    }

    return (
        <>
            <PreviewOverlay userType={previewUserType} slug={contentfulPage.slug} />
            <ContentfulLivePreviewProvider locale={contentfulLocale}>{children}</ContentfulLivePreviewProvider>
        </>
    );
}
